import Location from "./Location"

export default class Settings {
    static isPowerMode() {
        return localStorage.getItem('power-mode') === 'true'
    }

    static setPowerMode(value) {
        localStorage.setItem('power-mode', value)
    }

    static isGpsEnabled() {
        return localStorage.getItem('gps-enabled') === 'true'
    }

    static setGpsEnabled(value, onError) {
        //If enabling, verify that GPS is supported
        if (value) {
            Location.getGPSLocation(
                _ => localStorage.setItem('gps-enabled', true),
                error => onError?.(error)
            )
        } else {
            localStorage.setItem('gps-enabled', false)
        }
    }

    static isTelemetryEnabled() {
        return localStorage.getItem('telemetry-enabled') !== 'false'
    }

    static setTelemetryEnabled(value) {
        localStorage.setItem('telemetry-enabled', value)
    }
}